import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const fetchDocumentList = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)

    axios.post('/document/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.try_again) {
            dispatch('fetchDocumentList', payload)
        } else {
            commit('setDocumentList', res.data.response)                  
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/document/actions.js